import { ArrowLeft, Close } from '@zoomit/icons';
import { Image } from '@zoomit/primitives';
import { cn, Flex, Link } from '@zoomit/primitives';
import { Button, Typography } from '@zoomit/zoomit-ds';

import { BaseMediaUrl } from '../../constants/apis';
import { isMobile } from '../../constants/media-query';
import type { OverlaysGetResponse } from '../../types/overlays';

type Props = {
  data: OverlaysGetResponse['overlay'];
  handleClose: () => void;
  handleNavigate: () => void;
  bottomPosition: number;
};

export const SmallTemplate = (props: Props) => {
  const { data, handleClose, handleNavigate, bottomPosition } = props;

  return (
    <div
      data-testid="small-template"
      className={cn(
        'shadow-main bg-background1 outline-borderSecondary/50 fixed right-4 left-4 z-100 m-auto h-[104px] w-[calc(100%-32px)] rounded-md outline-5 *:text-white md:right-10 md:bottom-10 md:left-auto md:m-0 md:h-auto md:w-[350px]',
      )}
      style={isMobile ? { bottom: bottomPosition } : {}}
    >
      <Button
        className="outline-borderSecondary/50 bg-background1 absolute top-0 left-0 z-[2] flex h-6 w-6 -translate-[50%] cursor-pointer items-center justify-center rounded-full border-none p-0 outline md:h-8 md:w-8"
        onClick={handleClose}
        aria-label="Close overlay"
      >
        <Close className="fill-text" />
      </Button>
      <div className="flex flex-row md:flex-col">
        <Link href={data.url} onClick={handleNavigate} target="_blank" rel="noopener noreferrer">
          <div className="relative aspect-square h-[104px] w-full md:aspect-3/2 md:h-auto">
            <Image
              alt={data.image.alt || `overlay-${data.title}`}
              src={`${BaseMediaUrl}/${data.image.id}`}
              fill
              className="rounded-tr-md rounded-br-md object-cover md:rounded-tl-md md:rounded-br-none"
            />
          </div>
        </Link>
        {(data.title || data.description || data.buttonDescription) && (
          <Flex
            flexDirection="column"
            justifyContent="space-around"
            alignItems="flex-start"
            gap={0.8}
            className="px-4 py-2 text-right md:p-4"
          >
            {data.title && (
              <Link
                href={data.url}
                className="w-full"
                onClick={handleNavigate}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Typography className="font-primary text-body md:text-h5 line-clamp-2 cursor-pointer !text-right leading-6 font-bold md:leading-normal">
                  {data.title}
                </Typography>
              </Link>
            )}
            {data.description && (
              <Typography
                className="hidden cursor-default leading-[2] md:block"
                variant="body"
                fontWeight="normal"
              >
                {data.description}
              </Typography>
            )}
            {data.buttonDescription && (
              <Link
                href={data.url}
                className="w-full"
                onClick={handleNavigate}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button
                  className={cn(isMobile ? 'px-0' : '')}
                  size={isMobile ? 'auto' : 'full width'}
                  variant={isMobile ? 'text' : 'contained'}
                >
                  <Typography
                    className={cn('line-clamp-1', isMobile ? 'text-text' : 'text-white')}
                    variant="subhead-bold"
                  >
                    {data.buttonDescription}
                  </Typography>
                  <ArrowLeft className="fill-primary1" />
                </Button>
              </Link>
            )}
          </Flex>
        )}
      </div>
    </div>
  );
};
